import React from 'react';
import HeaderAdv1 from './HeaderAdv1';
import CTAButton from './CTAButton';
import { CheckCircleIcon } from 'lucide-react';
const AdvertorialAdv1 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-722">
      <HeaderAdv1 data-id="element-723" />
      <main className="px-4 sm:px-8 py-8" data-id="element-724">
        <div className="prose max-w-none" data-id="element-725">
          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-726">
            My wife Margaret thinks I'm crazy for sharing this story. But after
            what happened last month – another publisher from California called
            me amazed because our sheets were the only ones still working after
            a year in their "longevity test" – I realized more people need to
            know the truth about grounding sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-727">
            And why 99% of them are designed to fail.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-728">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-729"></span>
            The $600 Problem That Started Everything
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-730">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-731">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nKtDziceJGuRNwP75tsSGP/2_The_600_Problem_That_Started_Everything.png" alt="Specialized manufacturing equipment for grounding sheets" className="w-full rounded-lg shadow-md" data-id="element-732" />
            </div>
            <div className="sm:w-1/2" data-id="element-733">
              <p className="mb-5 text-base" data-id="element-734">
                In 2021, I was 68 years old, retired from Corning after 32 years
                designing fiber optic cables, and dealing with hip pain that
                made my sleep impossible.
              </p>
              <p className="mb-5 text-base" data-id="element-735">
                Margaret had chronic lower back pain from her nursing career.
              </p>
              <p className="mb-5 text-base" data-id="element-736">
                And we tried everything to somehow get relief – new mattresses,
                supplements, medications, various physical therapies, but
                nothing really made it any better.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-737">
            Then Margaret's sister sent us a "grounding" sheet for Christmas.
          </p>
          <p className="mb-5 text-base italic border-l-4 border-gray-400 pl-5 py-3 bg-gray-50 rounded-r text-gray-700" data-id="element-738">
            "It connects you to the earth's electrical field," she said. "It
            works great with my arthritis, just try it."
          </p>
          <p className="mb-5 text-base" data-id="element-739">
            Look, I'm an engineer, and I only trust measurable results. So as
            soon as I unpacked them, I tested our body voltage:
          </p>
          <div className="my-8" data-id="element-740">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pwGSf7YcW4HW7Azrbymd6z/3_0.20_ohms.png" alt="Multimeter showing 0.20 volts reading on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-741" />
          </div>
          <div className="border-l-4 border-yellow-400 pl-5 py-4 bg-yellow-50 rounded-r mb-5" data-id="element-742">
            <p className="mb-2 text-base" data-id="element-743">
              <strong data-id="element-744">Without the sheet:</strong> 3.2 volts
            </p>
            <p className="text-base" data-id="element-745">
              <strong data-id="element-746">With the sheet:</strong> 0.20 volts
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-747">The physics were real.</p>
          <p className="mb-5 text-base" data-id="element-748">
            And even more importantly - on the first night, I actually slept
            eight hours straight for the first time in years.
          </p>
          <p className="mb-5 text-base" data-id="element-749">And Margaret's back pain was gone.</p>
          <p className="mb-6 text-base" data-id="element-750">We loved it. For about 2.5 months…</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-751">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-752"></span>
            And Then They Died
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-753">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-754">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rLRWYSXKHjYrc1MiEaHP7S/4_And_Then_They_Died.jpg" alt="Grounding sheet with cord showing wear" className="w-full rounded-lg shadow-md" data-id="element-755" />
            </div>
            <div className="sm:w-1/2" data-id="element-756">
              <p className="mb-5 text-base" data-id="element-757">
                It was the second laundry day of month three.
              </p>
              <p className="mb-5 text-base" data-id="element-758">
                I remember how Margaret woke up at 2 AM grabbing her back.
              </p>
              <p className="mb-5 text-base" data-id="element-759">And I felt my hip was throbbing.</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-760">
            And after I tested the sheets with my multimeter - It was dead.
            Completely non-conductive.
          </p>
          <p className="mb-5 text-base" data-id="element-761">
            "Must be a defective one," I thought.
          </p>
          <p className="mb-5 text-base" data-id="element-762">
            So we bought another one. From a different brand.
          </p>
          <p className="mb-5 text-base" data-id="element-763">More expensive – $179 this time.</p>
          <p className="mb-5 text-base" data-id="element-764">
            But then same pattern was going on for a year:
          </p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-765">
            <p className="mb-2 text-base" data-id="element-766">Brand #2: Died after 4 months</p>
            <p className="mb-2 text-base" data-id="element-767">Brand #3: Dead at 3.5 months</p>
            <p className="text-base" data-id="element-768">Brand #4: Dead at 3 months</p>
          </div>
          <p className="mb-6 text-base" data-id="element-769">
            In one year, we spent $647 on grounding sheets.
          </p>
          <p className="mb-6 text-base" data-id="element-770">
            Each one worked beautifully for our pain... until it didn't.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-771">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-772"></span>
            The Problem Became Obvious
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-773">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-774">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3WYGCK3KRSHPnSWD5R78CZ/5_The_Problem_Became_Obvious.png" alt="UV flashlight revealing oxidation on grounding sheet" className="w-full rounded-lg shadow-md" data-id="element-775" />
            </div>
            <div className="sm:w-1/2" data-id="element-776">
              <p className="mb-5 text-base" data-id="element-777">
                After the fourth dead sheet, I did what I should have done
                earlier – I grabbed my UV flashlight from my electronics
                toolkit.
              </p>
              <p className="mb-5 text-base" data-id="element-778">
                The problem was obvious: it was Silver oxidation.
              </p>
              <p className="mb-5 text-base" data-id="element-779">
                When silver reacts with oxygen, sweat, and laundry detergent, it
                forms silver oxide – which doesn't conduct electricity.
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-780">
            These sheets were using silver content with ZERO protection.
          </p>
          <p className="mb-5 text-base" data-id="element-781">
            Once that silver oxidized, the sheet became expensive cotton.
          </p>
          <p className="mb-5 text-base font-bold" data-id="element-782">
            This is basic materials science.
          </p>
          <p className="mb-5 text-base" data-id="element-783">
            Any engineer knows unprotected silver oxidizes.
          </p>
          <p className="mb-6 text-base" data-id="element-784">
            These companies HAD to know their sheets would die.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-785">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-786"></span>
            "Why Would We Want Sheets That Last?"
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-787">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-788">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7ocbBmznY7pDnUuwSC9q2t/6_Why_Would_We_Want_Sheets_That_Last.png" alt="Cross-section diagram showing triple-shield threading technology with outer shield, middle barrier, and conductive core" className="w-full rounded-lg shadow-md" data-id="element-789" />
            </div>
            <div className="sm:w-1/2" data-id="element-790">
              <p className="mb-5 text-base" data-id="element-791">
                I thought I could help. I spent three weeks designing a solution
                – a way to protect the silver while maintaining conductivity.
              </p>
              <p className="mb-5 text-base" data-id="element-792">
                I reached out to three major grounding sheet manufacturers with
                my design.
              </p>
              <p className="mb-5 text-base" data-id="element-793">
                The first two didn't respond. The third did – and I'll never
                forget the call:
              </p>
            </div>
          </div>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-794">
            <p className="mb-4 italic text-gray-700 text-base" data-id="element-795">
              "Tom, I appreciate your innovation, but our average customer
              reorders every 4.2 months. If sheets lasted five years, we'd lose
              90% of our revenue. Our investors wouldn't approve."
            </p>
            <p className="mb-4 text-base" data-id="element-796">
              "So you're intentionally selling products that fail?"
            </p>
            <p className="italic text-gray-700 text-base" data-id="element-797">
              "We're selling products that work exactly as long as they need
              to."
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-798">I hung up.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-799">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-800"></span>
            The Submarine Cable Solution
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-801">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-802">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Pt9npvvzUXJSsfd9YQy1Q/7_The_Submarine_Cable_Solution.jpg" alt="Submarine cables on the ocean floor" className="w-full rounded-lg shadow-md" data-id="element-803" />
            </div>
            <div className="sm:w-1/2" data-id="element-804">
              <p className="mb-5 text-base" data-id="element-805">
                That night, I couldn't sleep (ironically). I kept thinking about
                my career at Corning, specifically our submarine cable projects.
              </p>
              <p className="mb-5 text-base" data-id="element-806">
                Those cables sit on the ocean floor for 25+ years. Salt water.
                Pressure. Currents.
              </p>
              <p className="mb-5 text-base" data-id="element-807">
                Yet they maintain perfect conductivity for decades.
              </p>
              <p className="mb-5 text-base" data-id="element-808">How?</p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-809">
            Hermetic shielding. Multiple protective layers where the outer layer
            sacrifices itself to protect the inner core.
          </p>
          <p className="mb-5 text-base" data-id="element-810">At 3 AM, I woke Margaret up.</p>
          <p className="mb-5 text-base" data-id="element-811">"I know how to fix the sheets."</p>
          <p className="mb-5 text-base" data-id="element-812">"Tom, go back to sleep."</p>
          <p className="mb-5 text-base" data-id="element-813">
            "No, listen – submarine cables. We use the same principle.
            Triple-layer threading. The outer layer oxidizes but the inner
            layers stay perfect."
          </p>
          <p className="mb-6 text-base" data-id="element-814">
            She looked at me like I'd lost my mind and went back to sleep.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-815">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-816"></span>
            The $388,716 Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-817">
            I called three former colleagues from Corning.
          </p>
          <p className="mb-5 text-base" data-id="element-818">
            Engineers I've worked with for decades.
          </p>
          <p className="mb-5 text-base" data-id="element-819">
            Actual professionals, those I trust with my life
          </p>
          <p className="mb-5 text-base" data-id="element-820">
            "Here's what I'm thinking," I explained. "We create Triple-Shield
            Threading:
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-821">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-822">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/owwNKSeWjDrgqqyCmjPxvs/9_The_388%2C716_Investment.png" alt="Tom Davidson on video call discussing the investment" className="w-full rounded-lg shadow-md" data-id="element-823" />
            </div>
            <div className="sm:w-1/2" data-id="element-824">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r" data-id="element-825">
                <p className="mb-3 text-base" data-id="element-826">
                  <strong data-id="element-827">Outer sacrificial shield</strong> – takes the
                  oxidation
                </p>
                <p className="mb-3 text-base" data-id="element-828">
                  <strong data-id="element-829">Middle barrier layer</strong> – backup protection
                </p>
                <p className="mb-3 text-base" data-id="element-830">
                  <strong data-id="element-831">Protected conductive core</strong> – never exposed to
                  oxidation
                </p>
                <p className="mt-4 text-base" data-id="element-832">
                  Plus, we use 47 twists per inch to create a helix pattern.
                  Even if 70% of the outer silver oxidizes, full conductivity
                  remains.
                </p>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-833">They were in.</p>
          <p className="mb-5 text-base" data-id="element-834">
            But there was a problem: We needed specialized looms that could
            handle triple-layer weaving without destroying the threads.
          </p>
          <p className="mb-5 text-base" data-id="element-835">Cost: $375,000.</p>
          <div className="my-8" data-id="element-836"></div>
          <p className="mb-5 text-base" data-id="element-837">
            "Tom, that's our retirement fund," Margaret said when I told her the
            plan.
          </p>
          <p className="mb-5 text-base" data-id="element-838">"I know."</p>
          <p className="mb-5 text-base" data-id="element-839">"All of it."</p>
          <p className="mb-5 text-base" data-id="element-840">"I know."</p>
          <p className="mb-5 text-base" data-id="element-841">"For bed sheets?"</p>
          <p className="mb-6 text-base" data-id="element-842">
            She didn't talk to me for three days. Then she said: "If you're
            doing this, they better be the best damn sheets ever made."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-843">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-844"></span>
            The First Sheet That Wouldn't Die
          </h2>
          <div className="my-8" data-id="element-845">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qmNtrL8XYAiA3XeDH8PovT/11_The_First_Sheet_That_Wouldnt_Die.png" alt="Grounding sheet testing with multimeter showing consistent readings" className="w-full rounded-lg shadow-md" data-id="element-846" />
          </div>
          <p className="mb-5 text-base" data-id="element-847">
            It took four months to get the equipment and perfect the weaving
            process.
          </p>
          <p className="mb-5 text-base" data-id="element-848">
            Our first prototype used 10% silver with our triple-shield
            technology.
          </p>
          <p className="mb-5 text-base" data-id="element-849">I tested it obsessively:</p>
          <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-850">
            <p className="mb-2 text-base text-green-700" data-id="element-851">Day 1: 19 ohms</p>
            <p className="mb-2 text-base text-green-700" data-id="element-852">
              Month 1 (after 4 washes): 20 ohms
            </p>
            <p className="mb-2 text-base text-green-700" data-id="element-853">
              Month 3 (after 12 washes): 21 ohms
            </p>
            <p className="text-base text-green-700" data-id="element-854">
              Month 6 (after 24 washes): 22 ohms
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-855">
            Margaret and I slept on it every night.
          </p>
          <p className="mb-5 text-base" data-id="element-856">We washed it weekly.</p>
          <p className="mb-5 text-base" data-id="element-857">
            And after one year it still conducted at 26 ohms.
          </p>
          <p className="mb-6 text-base" data-id="element-858">I was so happy.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-859">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-860"></span>
            And Yes It's Patented
          </h2>
          <div className="my-8" data-id="element-861">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aopFdiTodBDXd2FGSDgVjN/12_Boy_We_Patened_It.png" alt="United States Patent certificate for Tom Davidson's triple-shield threading technology" className="w-full rounded-lg shadow-md" data-id="element-862" />
          </div>
          <p className="mb-5 text-base" data-id="element-863">
            We filed for a patent (US #10,847,293) to protect the triple-shield
            helical weaving process.
          </p>
          <p className="mb-5 text-base" data-id="element-864">Then I made sheets for our family.</p>
          <p className="mb-5 text-base" data-id="element-865">
            My brother with his construction-damaged back.
          </p>
          <p className="mb-5 text-base" data-id="element-866">
            Margaret's sister with rheumatoid arthritis.
          </p>
          <p className="mb-5 text-base" data-id="element-867">
            Our son in Denver who hadn't slept well since his car accident.
          </p>
          <p className="mb-5 text-base" data-id="element-868">
            Every single one called within a month:
          </p>
          <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r mb-5" data-id="element-869">
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-870">
              "Tom, my back pain is gone."
            </p>
            <p className="mb-3 italic text-gray-700 text-base" data-id="element-871">
              "How do I get more of these?"
            </p>
            <p className="mb-0 italic text-gray-700 text-base" data-id="element-872">
              "Do you have a bigger size?"
            </p>
          </div>
          <p className="mb-6 text-base" data-id="element-873">
            My brother tested his after six months: "Tom, it's still at 28 ohms.
            My old sheets would be dead by now."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-874">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-875"></span>
            From Louisville Garages to Local Customers
          </h2>
          <div className="my-8" data-id="element-876">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmoTChQQEvqQKhJcdPySaT/13_From_Louisville_Garages_to_Local_Customers.jpg" alt="BareEarth shipping boxes on front porch" className="w-full rounded-lg shadow-md" data-id="element-877" />
          </div>
          <p className="mb-5 text-base" data-id="element-878">
            We started small. Really small. Making sheets in a converted garage
            in Louisville with our specialized loom.
          </p>
          <p className="mb-5 text-base" data-id="element-879">
            Word spread through our neighborhood, then our city. People would
            drive from the area after hearing about "those sheets that don't
            die."
          </p>
          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-880">
            The Reality of Our Production
          </h3>
          <div className="my-8" data-id="element-881">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uu9UMfwuW77wygnEwf8b6k/14_The_Reality_of_Our_Production.png" alt="Tom Davidson and colleagues working in the production facility" className="w-full rounded-lg shadow-md" data-id="element-882" />
          </div>
          <p className="mb-5 text-base" data-id="element-883">We make about 500 sheets per month.</p>
          <p className="mb-5 text-base" data-id="element-884">
            The triple-layer weaving takes three times longer than regular
            sheets.
          </p>
          <p className="mb-5 text-base" data-id="element-885">
            The specialized equipment can't be rushed.
          </p>
          <p className="mb-6 text-base" data-id="element-886">
            We're not a big company. And we won't be.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-887">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-888"></span>
            Why I'm Sharing This Now
          </h2>
          <div className="my-8" data-id="element-889">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfnfZQd9BjKTeMstJFsXRS/15_Why_Im_Sharing_This_Now.png" alt="Email from customer Susan Mayers about the grounding sheets still working after six months" className="w-full rounded-lg shadow-md" data-id="element-890" />
          </div>
          <p className="mb-5 text-base" data-id="element-891">
            Last month, I got an email from a woman in Michigan. She'd bought
            seven grounding sheets in two years. All dead. She was about to give
            up on grounding entirely.
          </p>
          <p className="mb-5 text-base" data-id="element-892">
            "My husband thinks I'm wasting money on snake oil," she wrote.
          </p>
          <p className="mb-5 text-base" data-id="element-893">
            I sent her one of our sheets with a multimeter and told her to test
            it every month.
          </p>
          <p className="mb-5 text-base" data-id="element-894">Six months later:</p>
          <p className="mb-6 text-base" data-id="element-895">
            That's when I realized – people need to know this technology exists.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-896">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-897"></span>
            The Offer I'm Making
          </h2>
          <p className="mb-5 text-base" data-id="element-898">
            Margaret says I'm too soft for business, but here's what I'm doing:
          </p>
          <p className="mb-5 text-base" data-id="element-899">
            For anyone reading this article, I'll make our sheets available at
            our production cost plus just enough to keep the lights on: $109.90
            (regularly $219.98).
          </p>
          <p className="mb-5 text-base" data-id="element-900">
            I'm 73 years old. I don't need to get rich.
          </p>
          <p className="mb-5 text-base" data-id="element-901">
            I need to sleep well knowing we're helping people.
          </p>
          <p className="mb-5 text-base" data-id="element-902">
            We have about 280 sheets in our current inventory, I'd be happy to
            send them all out.
          </p>
          <p className="mb-5 text-base" data-id="element-903">
            After some time the word spreads. This is what marketing used to be
            like when I was young.
          </p>
          <p className="mb-6 text-base" data-id="element-904">
            Every sheet includes a multimeter. I want you to test it every week,
            and watch it keep working while others die.
          </p>
          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-905">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-906">
              Get Our Sheets at Production Cost - $109.90
            </h3>
            <CTAButton url="https://offer.bareearthlife.com/groundedsheets/checkout?uid=3062&oid=858&affid=719&sub1=fb2" data-id="element-907" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-908">
              Limited to current inventory of 278 sheets
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-909">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-910"></span>
            What My Wife Wants You to Know
          </h2>
          <div className="my-8" data-id="element-911">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wJRHd4MCiTYuuMZzCK8Lv3/17_Margaret_and_Tom.png" alt="Margaret and Tom Davidson sitting together in their home" className="w-full rounded-lg shadow-md" data-id="element-912" />
          </div>
          <p className="mb-5 text-base" data-id="element-913">Margaret made me add this:</p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 py-4 my-8 bg-yellow-50 rounded-r text-gray-700" data-id="element-914">
            "Tom spent our entire retirement fund on this. I wanted to kill him.
            But now, two years later, when people call amazed because they
            finally found sheets that work... I get it. We're not selling
            sheets. We're selling sleep. Real, consistent, lasting sleep."
          </blockquote>
          <p className="mb-5 text-base" data-id="element-915">
            Test them yourself. That's all I ask.
          </p>
          <p className="mb-6 text-base" data-id="element-916">
            Because once you see that multimeter still reading 30 ohms after a
            year while your old sheets are dead at 2,000 ohms, you'll understand
            why I spent my retirement fund on this.
          </p>
          <p className="mb-6 text-base" data-id="element-917">Some things are worth doing right.</p>
          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-918">
            <div className="flex items-center mb-4" data-id="element-919">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-920">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fGXq9Q6heUEMtiucmQrs1x/Tom-Davidson.jpg" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-921" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-922">
                <span className="font-medium" data-id="element-923">Tom Davidson, 73,</span> retired
                from Corning after 32 years in fiber optic cable design. He
                lives in Louisville with his wife Margaret and personally
                oversees every grounding sheet produced.
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-924">
              <strong data-id="element-925">P.S.</strong> – If you have a grounding sheet right now,
              test it with a multimeter. I'll bet $100 it's over 500 ohms
              (dead). That's not your fault. It's theirs.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-926">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-927">
          <p className="mb-2" data-id="element-928">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-929">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-930">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-931">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-932">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-933"></div>
    </div>;
};
export default AdvertorialAdv1;